import { useEffect, useState } from "react";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";
import { EndingCTA } from "./components/ending-cta";
import { FAQs } from "./components/faqs";
import { About } from "./components/about";
import { Method } from "./components/method";
import { WhoIHelp } from "./components/who-i-help";
import { MainVideo } from "./components/main-video";

const useWindowScrolledHeight = () => {
  const [scrolledHeight, setScrolledHeight] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrolledHeight(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // return true if scrolled more than screen height
  return scrolledHeight > window.innerHeight;
};

const LandingPage = () => {
  const showStickyButton = useWindowScrolledHeight();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <div
        role="region"
        aria-label="Notifications (F8)"
        tabIndex={-1}
        style={{ pointerEvents: "none" }}
      >
        <ol
          tabIndex={-1}
          className="fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]"
        />
      </div> */}

      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        <main>
          <MainVideo />
          <WhoIHelp />
          <Method />
          <About />
          <FAQs />
          <EndingCTA />
        </main>
        <Footer />
      </div>

      {showStickyButton && (
        <div className="fixed bottom-0 left-0 w-full z-50 transition ease-in duration-300">
          <div className="md:hidden px-4 py-6 space-y-4 bg-background/80 backdrop-blur-sm border-t border-border flex justify-center">
            <a
              href="/book-a-call"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary-glow !py-3 !px-6 w-full justify-center"
            >
              <span>Book a call</span>
              <span className="btn-arrow-container !w-6 !h-6">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-arrow-right w-3 h-3 arrow-right"
                >
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-arrow-right w-3 h-3 arrow-left"
                >
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </span>
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default LandingPage;
